const ns = "FORMS_V2_SUBMISSIONS_SUBMISSION";
export const UPDATE = `${ns}_UPDATE`;
export const UPDATE_COMPLETE = `${ns}_UPDATE_COMPLETE`;
